import axiosInstance from "./AxiosInstance";

export default {
    get() {
        return axiosInstance({
            method: "get",
            url: "/company",
        });
    },
    create(body) {
        return axiosInstance({
            method: "post",
            url: "/company",
            data: body,
        });
    },
    update(id, body) {
        return axiosInstance({
            method: "patch",
            url: `/company/${id}`,
            data: body,
        });
    },
    delete(id) {
        return axiosInstance({
            method: "delete",
            url: `/company/${id}`,
        });
    },
};
